(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["providers.fadx-platform-api-client-v2"] = factory(require("axios"));
	else
		root["providers.fadx-platform-api-client-v2"] = factory(root["axios"]);
})(Object(typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__742__) => {
return 